import type { PaddingModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import SpacingModifier from "./SpacingModifier";

interface PaddingModifierProps {
  onChange: (modifiers: PaddingModifierValue[]) => void;
}

const PaddingModifierComponent: React.FC<PaddingModifierProps> = ({
  onChange,
}) => {
  return (
    <SpacingModifier
      onChange={onChange}
      config={{
        type: "padding",
        unifiedTooltipText: "Use unified padding",
        individualTooltipText: "Set individual padding",
      }}
    />
  );
};

export default PaddingModifierComponent;
